// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.search-icon[data-v-1d7e3315]{width:1.8rem;height:1.8rem}.block[data-v-1d7e3315]{position:relative;width:100%}.dropdown[data-v-1d7e3315]{background-color:#fff;width:100%;border-radius:1.2rem;padding:1.2rem 0;position:absolute;top:6.4rem;box-shadow:0 8px 25px 0 rgba(99,119,156,.2)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
